import styles from './form.module.scss';

export default function FormFilterContainer(props: React.PropsWithChildren<unknown>) {
  return <div className={styles.filter_container}>{props.children}</div>;
}
